import { useState, useEffect } from "react";
import { useInput } from "../hooks/useInput";
import ConfirmBox from "../components/ConfirmBox";
import FormBox from "../components/FormBox";
import evm from "../images/evm.png";
import six from "../images/six.png";

const HomePage = () => {
  const { setInput } = useInput();
  const [evmloading, evmsetLoading] = useState(false);
  const [evmbalance, evmsetBalance] = useState(null);
  const [evmconnected, evmsetConnected] = useState(false);
  const [evmcanFetch, evmsetCanFetch] = useState(true);
  const [evmaccount, evmsetAccount] = useState(null);
  const [evmweb3, evmsetWeb3] = useState(null);
  const [evmestimateGas, evmsetEstimateGas] = useState(null);

  const [protocolloading, protocolsetLoading] = useState(false);
  const [protocolbalance, protocolsetBalance] = useState(null);
  const [protocolconnected, protocolsetConnected] = useState(false);
  const [protocolcanFetch, protocolsetCanFetch] = useState(true);
  const [protocolaccount, protocolsetAccount] = useState(null);
  const [protocolestimateGas, protocolsetEstimateGas] = useState(null);

  // Separate state for the To box balance (disabled/display-only box)
  const [toloading, tosetLoading] = useState(false);
  const [tobalance, tosetBalance] = useState(null);

  const [customToAddress, setCustomToAddress] = useState("");

  const [isInput, setIsInput] = useState(true);
  const [from, setFrom] = useState({
    img: six,
    sign: evm,
    value: "6x0000....0000",
    name: "SIX Protocol - EVM"
  });
  const [to, setTo] = useState({
    img: six,
    name: "SIX Protocol"
  });

  // To chain is always locked to the opposite of From chain
  useEffect(() => {
    if (from.name === "SIX Protocol - EVM") {
      setTo({ img: six, name: "SIX Protocol" });
    } else {
      setTo({ img: six, sign: evm, name: "SIX Protocol - EVM" });
    }
    setCustomToAddress("");
  }, [from.name]);

  return isInput ? (
    <FormBox
      evmcanFetch={evmcanFetch}
      evmsetCanFetch={evmsetCanFetch}
      evmloading={evmloading}
      evmsetLoading={evmsetLoading}
      evmbalance={evmbalance}
      evmsetBalance={evmsetBalance}
      evmestimateGas={evmestimateGas}
      evmsetEstimateGas={evmsetEstimateGas}
      evmconnected={evmconnected}
      evmsetConnected={evmsetConnected}
      evmaccount={evmaccount}
      evmsetAccount={evmsetAccount}
      evmweb3={evmweb3}
      evmsetWeb3={evmsetWeb3}
      protocolcanFetch={protocolcanFetch}
      protocolsetCanFetch={protocolsetCanFetch}
      protocolloading={protocolloading}
      protocolsetLoading={protocolsetLoading}
      protocolbalance={protocolbalance}
      protocolsetBalance={protocolsetBalance}
      protocolestimateGas={protocolestimateGas}
      protocolsetEstimateGas={protocolsetEstimateGas}
      protocolconnected={protocolconnected}
      protocolsetConnected={protocolsetConnected}
      protocolaccount={protocolaccount}
      protocolsetAccount={protocolsetAccount}
      from={from}
      setFrom={setFrom}
      to={to}
      setTo={setTo}
      customToAddress={customToAddress}
      setCustomToAddress={setCustomToAddress}
      toloading={toloading}
      tosetLoading={tosetLoading}
      tobalance={tobalance}
      tosetBalance={tosetBalance}
      onNext={() => {
        setIsInput(false);
      }}
    />
  ) : (
    <ConfirmBox
      from={from}
      to={to}
      evmaccount={evmaccount}
      protocolaccount={protocolaccount}
      customToAddress={customToAddress}
      onBack={reset => {
        setIsInput(true);
        evmsetCanFetch(true);
        protocolsetCanFetch(true);
        if (reset) {
          setInput("0");
          setCustomToAddress("");
          evmsetBalance(null);
          protocolsetBalance(null);
          tosetBalance(null);
          evmsetLoading(true);
          protocolsetLoading(true);
          tosetLoading(false);
        }
      }}
    />
  );
};

export default HomePage;
